import React from 'react';

function getCartCountForCategory(cart, categoryId) {
    if (!cart || typeof cart !== 'object') return 0;
    return Object.values(cart).reduce((total, item) => {
        const itemCategoryId = item.category_id != null ? String(item.category_id) : '';
        const match = categoryId == null ? true : itemCategoryId === String(categoryId);
        return total + (match ? (item.quantity || 0) : 0);
    }, 0);
}

function CategoryList({ categories, cart, cartCountsByCategory, onCategoryChange }) {
    const allCategoriesCount = cartCountsByCategory?.total ?? getCartCountForCategory(cart, null);

    return (
        <div className="category-list">
            <button
                className={`category-list-item${allCategoriesCount > 0 ? ' category-list-item--has-count' : ''}`}
                onClick={() => onCategoryChange({ id: null, name: 'All Categories' })}
            >
                <span><span language="ar">جميع الفئات</span><span language="en">All Categories</span></span>
                {allCategoriesCount > 0 && (
                    <span className="category-list-item-count">{allCategoriesCount}</span>
                )}
            </button>
            {categories.map(category => {
                const count = cartCountsByCategory?.counts != null && String(category.id) in cartCountsByCategory.counts
                    ? cartCountsByCategory.counts[String(category.id)]
                    : getCartCountForCategory(cart, category.id);
                return (
                    <button
                        key={category.id}
                        className={`category-list-item${count > 0 ? ' category-list-item--has-count' : ''}`}
                        onClick={() => onCategoryChange(category)}
                    >
                        <span>{category.name}</span>
                        {count > 0 && (
                            <span className="category-list-item-count">{count}</span>
                        )}
                    </button>
                );
            })}
        </div>
    );
}

export default CategoryList;
